import styled from "styled-components";

export const ModalScroll = styled.div`
  height: 455px;
  overflow-y: auto;
  scroll-behavior: smooth;
  text-align: justify;
  padding-right: 10px;
`;

export default { ModalScroll };
